interface IJwt {
	token: string;
	uniqueName: string;
	nameId: string;
	email: string;
	expireAt: Date;
	issuedAt: Date;
}

class Jwt implements IJwt {
	token: string;
	uniqueName: string;
	nameId: string;
	email: string;
	expireAt: Date;
	issuedAt: Date;

	constructor(token: string, tokenDecoded: any) {
	    this.token = token;
	    this.uniqueName = tokenDecoded.unique_name;
	    this.nameId = tokenDecoded.nameid;
	    this.email = tokenDecoded.email;
	    this.expireAt = new Date(tokenDecoded.exp * 1000);
	    this.issuedAt = new Date(tokenDecoded.iat * 1000);
	}
}

export { Jwt, IJwt };
